import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Link as RouterLink, useHistory } from "react-router-dom";

import {
  Box,
  Button,
  Divider,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  Link,
  Typography,
} from "@material-ui/core";
import { ArrowBack, Visibility, VisibilityOff } from "@material-ui/icons";

import LoginCard from "./LoginCard";
import { getSignInSubscriptionData, propagateUrlTracing } from "../utils/utils";
import { useIntl } from "react-intl";
import { subscriptions } from "../messages";

export default function SignInForm({ onSubmit, routes }) {
  const intl = useIntl();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [subtitle, setSubtitle] = useState("");

  useEffect(() => {
    let iSubtitle = "";
    /*
    const trace = getQueryVariable(location.search, URL_TRACE_PARAM);
    const callback = getQueryVariable(location.search, URL_CALLBACK_PARAM);
    if (trace === URL_TRACE_VALUES.SUBSCRIBE) {
      //if (callback !== MANAGER_ROUTES.SUBSCRIPTION_START) {
      if (isJoinSubscribeBuyUrl(callback)) {
        iSubtitle = intl.formatMessage(subscriptions.buyLogin);
      } else {
        iSubtitle = intl.formatMessage(subscriptions.noBuyLogin);
      }
    }*/
    if (getSignInSubscriptionData()?.isSubscribing)
      iSubtitle = intl.formatMessage(subscriptions.buyLogin);
    setSubtitle(iSubtitle);
  }, [intl]);

  //console.log("????????????", getSignInSubscriptionId());

  function handleSubmit(event) {
    event.preventDefault();
    onSubmit(
      event.target.email.value.trim().toLowerCase(),
      event.target.password.value
    );
  }

  function handleClickShowPassword() {
    setShowPassword(!showPassword);
  }

  function handleMouseDownPassword(event) {
    event.preventDefault();
  }

  const backButton = (
    <Button
      onClick={() => history.push(routes.SIGN_IN + propagateUrlTracing())}
      startIcon={<ArrowBack />}
      color="inherit"
    >
      <FormattedMessage id="common.back" defaultMessage="Indietro" />
    </Button>
  );

  return (
    <LoginCard back={backButton} subtitle={subtitle}>
      {subtitle && <Box style={{ paddingTop: 50 }}></Box>}
      <Box id="login-data" tabIndex={0}>
        <Typography>
          <FormattedMessage
            id="component.signin.loginText"
            defaultMessage="Se sei già registrato inserisci le credenziali del tuo account"
          />
        </Typography>
      </Box>

      <form onSubmit={handleSubmit}>
        <FormControl margin="normal" required fullWidth>
          <InputLabel htmlFor="email">
            <FormattedMessage id="common.email" defaultMessage="Email" />
          </InputLabel>
          <Input id="email" name="email" autoComplete="email" type="email" />
        </FormControl>
        <FormControl margin="normal" required fullWidth>
          <InputLabel htmlFor="password">
            <FormattedMessage id="common.password" defaultMessage="Password" />
          </InputLabel>
          <Input
            name="password"
            type={showPassword ? "text" : "password"}
            id="password"
            autoComplete="current-password"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  //aria-label="toggle password visibility"
                  aria-label={
                    showPassword ? "Password visualizzata" : "Password nascosta"
                  }
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <FormControl margin="normal" fullWidth>
          <Button type="submit" fullWidth variant="contained" color="primary">
            <FormattedMessage
              id="component.signin.title"
              defaultMessage="Accedi"
            />
          </Button>
        </FormControl>
        <FormControl margin="normal" fullWidth>
          <Link
            component={RouterLink}
            to={routes.PASSWORD_FORGET + propagateUrlTracing()}
          >
            <FormattedMessage
              id="component.signin.forgotPassword"
              defaultMessage="Se hai dimenticato la password clicca qui per reimpostare le nuove credenziali"
            />
          </Link>
        </FormControl>
        <Box mt={6}>
          <Divider variant="middle" />
        </Box>
        <FormControl margin="normal" fullWidth id="login-data" tabIndex={0}>
          <Typography>
            <FormattedMessage
              id="component.signin.registerText"
              defaultMessage="Se non sei in possesso di un account, registrati!"
            />
          </Typography>
        </FormControl>
        <FormControl margin="normal" fullWidth>
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => history.push(routes.SIGN_UP + propagateUrlTracing())}
          >
            <FormattedMessage
              id="component.signin.register"
              defaultMessage="Registrati"
            />
          </Button>
        </FormControl>
      </form>
    </LoginCard>
  );
}
